import React, { useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Box, Button, Link, Modal, TextField } from "@mui/material";
import SlidingPanel from "react-sliding-side-panel";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { styled } from "@mui/material/styles";
import { GridCloseIcon } from "@mui/x-data-grid/components/icons";
import DatePicker from "../../../../Supporting files/DatePicker/DatePicker";
import SelectDropdown from "../../../../Supporting files/SelectDropdown/SelectDropdown";
import RKTextField from "../../../../Supporting files/RKTextField/RKTextField";
import SearchDropdown from "../../../../Supporting files/SearchDropdown/SearchDropdown";

interface Props {
  open_status: boolean;
  attrName: any;
  value_update: Function;
}

const MassUpdate: React.FC<Props> = ({
  open_status,
  attrName,
  value_update,
}) => {
  const [massUpdate, setMassUpdate] = React.useState(false);
  const [massField, setMassField] = React.useState("");
  const [regDate, setRegDate] = React.useState<Date | null>(null);
  const [claimStatus, setClaimStatus] = React.useState("");
  const [clientId, setClientId] = React.useState("");

  const claimStatus_data = [
    { key: "Yes", value: "Yes" },
    { key: "No", value: "No" },
  ];
   const clientid_data = [
     { label: "CLT012 - Evervent", value: "CLT012 - Evervent" },
     { label: "CLT013 - Evervent", value: "CLT013 - Evervent" },
     { label: "CLT014 - Evervent", value: "CLT014 - Evervent" },
     { label: "CLT015 - Evervent", value: "CLT015 - Evervent" },
   ];

  const updateMasterState = (
    attrName: any,
    value: string | boolean | number
  ) => {
    attrName(value);
  };
  return (
    <SlidingPanel
      type={"right"}
      isOpen={open_status}
      size={75}
      panelClassName="sliding-panel"
      // backdropClicked={() => value_update(attrName, false)}
    >
      <div>
        <Grid container spacing={3} alignItems="center">
          <Grid xs={10}>
            <h4 className="mb-0 mt-3 text-left">Mass Update</h4>
          </Grid>
          <Grid xs={2} textAlign="end" className="mt-3">
            <GridCloseIcon
              onClick={() => {
                value_update(attrName, false);
              }}
            />
          </Grid>
          <Grid xs={12} className="mb-4 pt-0">
            <hr />
          </Grid>
        </Grid>
        <div className="scrollable_area">
          <div>
            <Grid container spacing={3} className="mb-4">
              <Grid xs={6}>
                <RKTextField
                  class_name="inputField"
                  title="Mass Field"
                  value={massField}
                  attrName={setMassField}
                  value_update={updateMasterState}
                  warn_status={false}
                />
              </Grid>
              <Grid xs={6} className="inputField">
                <DatePicker
                  class_name="inputField"
                  title="Reg. Date"
                  value={regDate}
                  attrName={setRegDate}
                  value_update={updateMasterState}
                  error_message="Please enter Reg. Date"
                  warn_status={false}
                />
              </Grid>
              <Grid xs={6} className="inputField">
                <SelectDropdown
                  class_name="inputField"
                  title="Claim"
                  value={claimStatus}
                  attrName={setClaimStatus}
                  value_update={updateMasterState}
                  dropdown_data={claimStatus_data}
                  warn_status={false}
                />
              </Grid>
              <Grid xs={6} className="inputField">
                <SearchDropdown
                  class_name="inputField"
                  title="Search Client ID"
                  value={clientId}
                  attrName={setClientId}
                  value_update={updateMasterState}
                  data={clientid_data}
                  warn_status={false}
                  error_message="Please select client"
                />
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid xs={12} className="ctaBtn" style={{ textAlign: "center" }}>
                <Button
                  variant="contained"
                  className="submitBtn"
                  onClick={() => {
                    setMassUpdate(true);
                  }}
                >
                  Upload
                </Button>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </SlidingPanel>
  );
};

export default MassUpdate;
